import { render, staticRenderFns } from "./ServiceBadge.vue?vue&type=template&id=2498295c&lang=pug"
import script from "./ServiceBadge.vue?vue&type=script&lang=ts"
export * from "./ServiceBadge.vue?vue&type=script&lang=ts"
import style0 from "./ServiceBadge.vue?vue&type=style&index=0&id=2498295c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports